// 分析種別
export const AnalysisKind = Object.freeze({
  SOUDAN: 'soudan',
  KEIYAKU: 'keiyaku',
  KINGAKU: 'kingaku',
});

// 分析種別
export const AnalysisKinds = Object.freeze([
  {
    key: AnalysisKind.SOUDAN,
    value: '相談件数',
    prefix: '',
    cellWidth: 60, // セル幅
    cellAlign: 'center', // セルの配置
  },
  {
    key: AnalysisKind.KEIYAKU,
    value: '契約件数',
    prefix: 'KEI_',
    cellWidth: 60, // セル幅
    cellAlign: 'center', // セルの配置
  },
  {
    key: AnalysisKind.KINGAKU,
    value: '契約金額',
    prefix: 'KIN_',
    cellWidth: 92, // セル幅
    cellAlign: 'right', // セルの配置
  },
]);

// 比較種別
export const ComparisonKind = Object.freeze({
  CURRENT_BEFORE: 'currentBefore', // 昨対比
  BIG_SMALL: 'bigSmall', // 工事／小工事・管理
});

// 比較種別
export const ComparisonKinds = Object.freeze([
  {
    key: ComparisonKind.CURRENT_BEFORE,
    value: '昨対比',
    key1: 'BEFORE', // 比較用のキー値1(前期)
    key2: 'CURRENT', // 比較用のキー値2(今期）
    key1Css: 'before_cell', // 比較用のキー値1のCSSクラス名
    key2Css: 'current_cell', // 比較用のキー値1のCSSクラス名
  },
  {
    key: ComparisonKind.BIG_SMALL,
    value: '工事／管・小',
    key1Value: '工事',
    key1: 'BIG', // 比較用のキー値1(工事)
    key2: 'SMALL', // 比較用のキー値2(管・小）
    key2Value: '管・小',
    key1Css: 'big_cell', // 比較用のキー値1のCSSクラス名
    key2Css: 'small_cell', // 比較用のキー値1のCSSクラス名
  },
]);

// 棒線グラフのY軸の目盛り間隔を計算
export function calcMajorUnit(counters) {
  const maxValue = Math.max(...counters.map((item) => item.value), 0);

  // 目盛り間隔を計算（例: 最大値を5分割する）
  const roughUnit = Math.ceil(maxValue / 5);

  // 目盛り間隔を10の倍数に調整
  const magnitude = Math.pow(10, Math.floor(Math.log10(roughUnit)));
  return Math.ceil(roughUnit / magnitude) * magnitude;
}

// 棒グラフのY軸の最大値を計算
export function calcMaxValue(counts) {
  // データの最大値を取得
  const maxValue = Math.max(...counts.map((item) => item.value), 0);

  // 最大値を10の倍数に丸める
  const magnitude = Math.pow(10, Math.floor(Math.log10(maxValue)));
  return Math.ceil(maxValue / magnitude) * magnitude;
}

// 担当の前期・今期がともに0かどうか（0の担当は一覧・グラフに出さない）
export function isTanEmpty(items, prefix, tanType, tanCd) {
  const keys = ['BEFORE', 'CURRENT'].flatMap((period) => [
    `${prefix}${period}_${tanType}_${tanCd}`, // 件数・金額
    `${prefix}${period}_${tanType}_POINT_${tanCd}`, // ポイント換算
  ]);
  return items.every((item) => keys.every((key) => !Number(item[key])));
}
